import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2, LogIn } from "lucide-react";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="max-w-md mx-auto px-4 py-20">
      <div className="bg-white border border-slate-200 rounded-xl p-10">
        <LogIn className="w-8 h-8 text-emerald-600 mb-4" />
        <h1 className="font-heading text-3xl tracking-tight mb-2">Welcome back</h1>
        <p className="text-sm text-slate-500 mb-8">Log in to your affiliate account.</p>
        {error && <p data-testid="login-error" className="text-sm text-rose-600 bg-rose-50 border border-rose-200 rounded-lg px-4 py-3 mb-5">{error}</p>}
        <form onSubmit={onSubmit} className="space-y-5">
          <div>
            <label className="uppercase text-xs tracking-[0.2em] font-semibold text-slate-500 block mb-2">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input"
              className="w-full px-4 py-3 rounded-lg bg-slate-50 border border-slate-200 focus:outline-none focus:ring-2 focus:ring-emerald-500" />
          </div>
          <div>
            <label className="uppercase text-xs tracking-[0.2em] font-semibold text-slate-500 block mb-2">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input"
              className="w-full px-4 py-3 rounded-lg bg-slate-50 border border-slate-200 focus:outline-none focus:ring-2 focus:ring-emerald-500" />
          </div>
          <button type="submit" disabled={loading} data-testid="login-submit-button"
            className="w-full flex items-center justify-center gap-2 py-3.5 rounded-full bg-emerald-600 text-white font-medium hover:bg-emerald-500 transition-colors duration-200 disabled:opacity-60">
            {loading && <Loader2 className="w-4 h-4 animate-spin" />} Log in
          </button>
        </form>
        <div className="flex items-center justify-between mt-6 text-sm">
          <Link to="/forgot-password" data-testid="forgot-password-link" className="text-slate-500 hover:text-slate-900 transition-colors duration-200">Forgot password?</Link>
          <Link to="/signup" data-testid="login-to-signup-link" className="font-medium text-emerald-700 hover:text-emerald-800 transition-colors duration-200">Join free →</Link>
        </div>
      </div>
    </main>
  );
}
